export const rootUrl =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : `https://${window.location.host}`

export const wsUrl =
  process.env.NODE_ENV === 'development' ? 'ws://localhost:3000/cable' : `wss://${window.location.host}/cable`
